import React from "react";
import PropTypes from "prop-types";
import SmartImage from "../../utils/ImageHandler";

const Image = React.forwardRef((props, ref) => {
  const { src, sm, md, lg, alt, className, style } = props;

  // Changed to srcSet to suppress the error and coincide with the list here:
  // https://reactjs.org/docs/dom-elements.html#all-supported-html-attributes

  return (
    <picture>
      {sm && (
        <source srcSet={SmartImage(src, sm)} media="(max-width: 767.98px)" />
      )}
      {md && (
        <source srcSet={SmartImage(src, md)} media="(max-width: 991.98px)" />
      )}
      {lg && <source srcSet={SmartImage(src, lg)} />}
      <img
        ref={ref}
        src={SmartImage(src, lg)}
        alt={alt}
        className={`${className}`}
        style={style}
        loading="lazy"
      />
    </picture>
  );
});

export default Image;

Image.propTypes = {
  src: PropTypes.string,
  sm: PropTypes.string,
  md: PropTypes.string,
  lg: PropTypes.string,
  className: PropTypes.string,
  alt: PropTypes.string,
};

Image.defaultProps = {
  src: null,
  sm: null,
  md: null,
  lg: null,
  className: null,
  alt: null,
};
